module.exports = __webpack_public_path__ + "9779d9a1/img/placeholder.888fcd0b.svg";